/**
 * Performance optimization utilities
 */

// Check if the browser supports native image lazy loading
export const supportsNativeLazyLoading = () => {
  return 'loading' in HTMLImageElement.prototype;
};

// Check if the browser supports the Intersection Observer API
export const supportsIntersectionObserver = () => {
  return 'IntersectionObserver' in window;
};

// Preload critical images for better performance
export const preloadCriticalImages = (imageUrls) => {
  if (!imageUrls || !Array.isArray(imageUrls) || imageUrls.length === 0) return;
  
  imageUrls.forEach(imageUrl => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = imageUrl;
    document.head.appendChild(link);
  });
};

// Defer non-critical CSS
export const deferNonCriticalCSS = (cssUrl) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = cssUrl;
  link.media = 'print';
  link.onload = () => {
    link.media = 'all';
  };
  document.head.appendChild(link);
};

// Optimize rendering by avoiding layout shifts
export const optimizeLayoutShifts = () => {
  // Find all images without dimensions and set defaults
  const images = document.querySelectorAll('img:not([width]):not([height])');
  images.forEach(img => {
    img.style.aspectRatio = '16/9';
  });
  
  // Find all elements that might cause shifts
  const dynamicElements = document.querySelectorAll('[data-dynamic-height]');
  dynamicElements.forEach(elem => {
    elem.style.minHeight = elem.dataset.minHeight || '100px';
  });
};

// Initialize all performance optimizations
export const initPerformanceOptimizations = (options = {}) => {
  const {
    criticalImages = [],
    nonCriticalCSS = [],
    optimizeLayouts = true,
    optimizeFonts = true,
  } = options;
  
  // Preload critical images
  if (criticalImages.length > 0) {
    preloadCriticalImages(criticalImages);
  }
  
  // Defer non-critical CSS
  if (nonCriticalCSS.length > 0) {
    nonCriticalCSS.forEach(cssUrl => deferNonCriticalCSS(cssUrl));
  }
  
  // Optimize layouts to prevent shifts
  if (optimizeLayouts) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', optimizeLayoutShifts);
    } else {
      optimizeLayoutShifts();
    }
  }
  
  // Optimize font loading
  if (optimizeFonts) {
    // optimizeFontLoading();
  }
  
  // Additional optimizations
  if (!supportsNativeLazyLoading()) {
    // Fallback for browsers that don't support native lazy loading
    import('lazysizes').then(() => {
      console.log('Lazysizes loaded for fallback lazy loading');
    });
  }
}; 